import { PROJECTS } from "@/data/projects";
import { ProjectCard } from "@/components/site/ProjectCard";
import { MaskedLines, Reveal } from "@/components/site/Motion";

export const Work = () => (
  <section id="work" data-testid="work-section" aria-labelledby="work-title" className="px-6 py-24 lg:px-12 lg:py-36">
    <div className="mb-16 grid grid-cols-1 gap-6 md:grid-cols-12 lg:mb-24">
      <p className="label text-mute md:col-span-3">(01) Selected Work</p>
      <h2 id="work-title" className="font-display text-4xl font-medium leading-[0.95] tracking-[-0.045em] sm:text-5xl md:col-span-6 lg:text-7xl">
        <MaskedLines inView lines={["Selected", "projects"]} />
      </h2>
      <Reveal className="md:col-span-3 md:self-end">
        <p className="text-sm leading-relaxed text-mute">
          Four projects across identity, packaging, campaign and motion. Student and speculative work is labelled as such.
        </p>
      </Reveal>
    </div>
    <ul className="grid grid-cols-1 gap-x-10 gap-y-20 md:grid-cols-2 lg:gap-x-16 lg:gap-y-28">
      {PROJECTS.map((p, i) => (
        <li key={p.slug} className={i % 2 === 1 ? "md:mt-40" : ""}>
          <Reveal delay={i % 2 ? 0.1 : 0}>
            <ProjectCard project={p} />
          </Reveal>
        </li>
      ))}
    </ul>
  </section>
);
